<div class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      {{'appointments.gui.labels.Multi Select Groups' | translate}}
    </h2>
    <button (click)="close()" class="print-history-popup-close" aria-label="close popup"></button>
    <div style="display: flex; align-items: center; flex-direction: column;">
      <mat-radio-group [(ngModel)]="selectedGroupIndex" (change)="onDefaultGroupChange()">
        <div *ngFor="let group of groupSelections; let i = index"
          style="display: flex; flex-direction: row; align-items: center; gap: 1em;">

          <!-- Radio -->
          <mat-radio-button [value]="i">
            {{'appointments.gui.labels.Group' | translate}} {{ i + 1 }}
          </mat-radio-button>

          <!-- Multi-select -->
          <mat-form-field style="width: 300px; margin-inline-start: 10px;">
            <mat-select [value]="group.ids" multiple (selectionChange)="updateGroupSelection(i, $event.value)">
              <mat-option *ngFor="let option of isByRooms ? roomList : doctorList"
                [value]="isByRooms ? option.AutoIndex : option.UID">
                {{ isByRooms ? option.RoomName : option.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Delete button -->
          <button mat-icon-button color="warn" (click)="deleteGroup(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-radio-group>

      <button class="blue-btn" (click)="addNewGroup()">
        {{'appointments.gui.buttons.Add Group' | translate}}
      </button>
    </div>
  </div>
</div>